import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { palette } from "../../../../assets/styles/Palette";
import {
  Body1,
  Body2,
  Sub2,
  H4,
} from "../../../../assets/styles/Typography";
import { RadioButton } from "../../../../assets/styles/InputStyle";
import MoleculeInfoContentPopup from "../molecules/MoleculeInfoContentPopup";
import MoleculeContentSettingPopup from "../molecules/MoleculeContentSettingPopup";
import images from "../../../../assets/styles/Images";
import { Button } from "../../../../assets/styles/ButtonStyle";
import { BoxWrap } from "../../../../assets/styles/BusinessAnalysisStyle";
import PopupWrap from "../../../../assets/styles/Popup";
import { useAtom } from "jotai";
import { IS_LOGGED_IN, CUSTOMER_NAME } from "../../../AtomStates";
import {
  getInfoBoardContentsDetailOnServer,
  updateInfoBoardContentOnServer,
  updateInfoBoardContentsOnServer,
} from "../../../../utils/indexedDB";
import OrganismDisplayViewInfoPreview from "../../../Global/components/organisms/OrganismDisplayViewInfoPreview";
import OrganismDisplayViewInfoMealPreview from "../../../Global/components/organisms/OrganismDisplayViewInfoMealPreview";
import MoleculeTitleCorrection from "../../../CreateEducationContentPage/components/molecules/MoleculeTitleCorrection";
import MoleculeMarkdownEditPopup from "../molecules/MoleculeMarkdownEditPopup";
import MoleculeMealEditPopup from "../molecules/MoleculeMealEditPopup";
import MoleculeEduInfoTypeSelectPopup from "../molecules/MoleculeEduInfoTypeSelectPopup";

const OrganismEduInfoContentList = ({
  contentList = [],
  lotationDetail = null,
  onLotationUpdate = null,
  onContentListUpdate = null,
}) => {
  const [isLoggedIn, setIsLoggedIn] = useAtom(IS_LOGGED_IN);
  const [viewFilter, setViewFilter] = useState("all");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const selectedTab = "전학년";
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [contentToDelete, setContentToDelete] = useState(null);

  // 미리보기 관련 state
  const [showTemplatePreview, setShowTemplatePreview] = useState(false);
  const [templateToPreview, setTemplateToPreview] = useState(null);
  const [previewJsonData, setPreviewJsonData] = useState(null);
  const [previewMarkdownData, setPreviewMarkdownData] = useState(null);
  const [previewTitleData, setPreviewTitleData] = useState(null);
  const [previewContentsPurpose, setPreviewContentsPurpose] = useState(null);
  const [previewWidth, setPreviewWidth] = useState(0);
  const [previewHeight, setPreviewHeight] = useState(0);
  const [previewContentsDesignConcept, setPreviewContentsDesignConcept] =
    useState(null);
  const [previewMealData, setPreviewMealData] = useState(null);
  const [previewNoticeText, setPreviewNoticeText] = useState("");
  const [contentsTypeState, setContentsTypeState] = useState(null);

  // 복사 성공 팝업 관련 state
  const [showCopySuccessPopup, setShowCopySuccessPopup] = useState(false);
  const [copiedInfo, setCopiedInfo] = useState({ type: "", content: "" });

  // 콘텐츠 설정 팝업 관련 state
  const [showContentSettingPopup, setShowContentSettingPopup] = useState(false);

  // 식단 수정 팝업 관련 state
  const [showMealEditPopup, setShowMealEditPopup] = useState(false);
  const [contentToEditMeal, setContentToEditMeal] = useState(null);
  
  // 마크다운 수정 관련 state
  const [showMarkdownEditPopup, setShowMarkdownEditPopup] = useState(false);
  const [contentToEditMarkdown, setContentToEditMarkdown] = useState(null);
  const [editingTitle, setEditingTitle] = useState("");

  const [linkUrl, setLinkUrl] = useState("");
  const [showTypeSelectPopup, setshowTypeSelectPopup] = useState(false);
  const [selectedContentForType, setSelectedContentForType] = useState(null);
  const [customerName, setCustomerName] = useAtom(CUSTOMER_NAME);


  const typeOptions = [
    { value: "all", label: "전체" },
    //  { value: "allgrade", label: "전학년" },
    { value: "grade1", label: "1학년" },
    { value: "grade2", label: "2학년" },
    { value: "grade3", label: "3학년" },
    { value: "teachers_office", label: "교무실" },
    { value: "gym", label: "체육관" },
    { value: "cafeteria", label: "식당" },
    { value: "nurse_office", label: "양호실" },
    { value: "music_room", label: "음악실" },
    { value: "science_lab", label: "과학실" },
    { value: "art_room", label: "미술실" },
    { value: "auditorium", label: "강당" },
    { value: "library", label: "도서관" },
  ];

  // 콘텐츠 리스트 필터링 (라디오 버튼 선택에 따름)
  const getDisplayedContentList = () => {
    if (viewFilter === "all") {
      return contentList;
    }
    // if (viewFilter === "allgrade") {
    //   const gradeLabels = ["1학년", "2학년", "3학년"];
    //   return contentList.filter((content) =>
    //     // content.contentsPurpose가 gradeLabels 배열에 포함되는지 확인
    //     gradeLabels.includes(content.contentsPurpose)
    //   );
    // }
    const selectedType = typeOptions.find((type) => type.value === viewFilter);
    if (selectedType) {
      return contentList.filter(
        (content) => content.zones && content.zones.includes(selectedType.label)
      );
    }
    return contentList;
  };

  
  const getConceptName = (conceptId) => {
    switch (conceptId) {
      case "concept1":
        return "기본 테마";
      default:
        return "기본 테마";
    }
  };

  const handleAddContent = () => {
    setIsPopupOpen(true);
  };

  const handleContentSetting = () => {
    setShowContentSettingPopup(true);
  };

  const handleCloseContentSettingPopup = () => {
    setShowContentSettingPopup(false);
  };

  const handleCloseTypeSelectPopup = () => {
    setshowTypeSelectPopup(false);
    setSelectedContentForType(null);
  };

  const handleClosePopup = async () => {
    setIsPopupOpen(false);
    // 팝업이 닫힐 때 lotationDetail을 새로고침하여 최신 편성 상태를 반영
    if (onLotationUpdate) {
      await onLotationUpdate();
    }
  };

  // designConcept에 따른 이미지 반환 함수
  const getDesignConceptImage = (conceptId) => {
    switch (conceptId) {
      case "healthy":
        return "healthy";
      case "happy":
        return "happy";
      default:
        return "default";
    }
  };

  const handleTemplatePreview = async (contentId) => {
    try {
      // 서버에서 최신 데이터 가져오기
      const response = await getInfoBoardContentsDetailOnServer(contentId,);
      const latestContent = response.data || response;
      // console.log("🚀 ~ latestContent:", latestContent);

      if (!latestContent) {
        console.error("콘텐츠 데이터가 없습니다.");
        return;
      }

      if (latestContent.contentsType === "meal") {
        setPreviewMealData(latestContent.contentGeneratorMeal);
        setPreviewNoticeText(latestContent.nutritionMessage);
      } else {
        setPreviewJsonData(latestContent.contentGeneratorJson);
        setPreviewMarkdownData(latestContent.contentGeneratorMarkdown);
        setPreviewTitleData(latestContent.contentGeneratorTitle);
        setPreviewContentsPurpose(latestContent.contentsPurpose);
        setPreviewContentsDesignConcept(getConceptName(latestContent.designConcept));
      }

      if (latestContent.contentsType === "link") {
        setLinkUrl(latestContent.linkUrl);
      }

      if (latestContent.viewDevice) {
        setPreviewWidth(parseInt(latestContent.viewDevice.deviceWidth));
        setPreviewHeight(parseInt(latestContent.viewDevice.deviceHeight));
      }

      setContentsTypeState(latestContent.contentsType);

      setTemplateToPreview({
        category: getConceptName(latestContent.designConcept),
        title: latestContent.dataAnalysis?.title,
        customer: latestContent.customer,
        image: getDesignConceptImage(latestContent.designConcept),
      });
      setShowTemplatePreview(true);
    } catch (error) {
      console.error("미리보기 데이터 로딩 실패:", error);

      // 에러 시 기존 로컬 데이터 사용
      const content = contentList.find((c) => c._id === contentId);
      if (content) {
        if (content.contentsType === "meal") {
          setPreviewMealData(content.contentGeneratorMeal);
          setPreviewNoticeText(content.nutritionMessage);
        } else {
          setPreviewJsonData(content.contentGeneratorJson);
          setPreviewMarkdownData(content.contentGeneratorMarkdown);
          setPreviewTitleData(content.contentGeneratorTitle);
          setPreviewContentsPurpose(content.contentsPurpose);
          setPreviewContentsDesignConcept(content.designConcept);
        }

        if (content?.viewDevice) {
          setPreviewWidth(parseInt(content.viewDevice.deviceWidth));
          setPreviewHeight(parseInt(content.viewDevice.deviceHeight));
        }

        setTemplateToPreview({
          category: content.designConcept,
          title: content.dataAnalysis?.title,
          customer: content.customer,
          image: getDesignConceptImage(content.designConcept),
        });
        setShowTemplatePreview(true);
      }
    }
    // 창 history 스택에 현재 창 상태를 저장하고 미리보기 창을 추가
    window.history.replaceState({ page: "page" }, "", window.location.pathname);
    window.history.pushState({ overlay: true }, "", "?preview");
  };

  const handleTypeChange = (content) => {
    setSelectedContentForType(content);
    setshowTypeSelectPopup(true);
  };

  const handleCloseTemplatePreview = () => {
    setShowTemplatePreview(false);
    setTemplateToPreview(null);
    window.history.replaceState({ page: "page" }, "", window.location.pathname);
  };

  const handleEditTitle = async (content) => {
    try {
      // 먼저 서버에서 최신 데이터 가져오기
      const response = await getInfoBoardContentsDetailOnServer(content._id);
      const latestContent = response.data || response;
  
      
      setEditingTitle(latestContent.dataAnalysis?.title || "");
      // 콘텐츠 타입이 general 또는 link인 경우 마크다운 수정 팝업 표시
      if (latestContent.contentsType === "general" || latestContent.contentsType === "link" || latestContent.contentsType === "custom") {
        // console.log("마크다운 수정 팝업 표시");
        setContentToEditMarkdown(latestContent);
        setShowMarkdownEditPopup(true);
      } else {
        // console.log("식단 수정 팝업 표시 (타입:", latestContent.contentsType, ")");
        // 그 외의 경우 식단 수정 팝업 표시
        setContentToEditMeal(latestContent);
        setShowMealEditPopup(true);
      }
    } catch (error) {
      console.error("콘텐츠 상세 정보를 가져오는 중 오류 발생:", error);
      // 에러 발생 시 로컬 데이터로 타입 확인
      setEditingTitle(content.dataAnalysis?.title || "");

      if (content.contentsType === "general" || content.contentsType === "link" || content.contentsType === "custom") {
        console.log("마크다운 수정 팝업 표시 (로컬 데이터 사용)");
        setContentToEditMarkdown(content);
        setShowMarkdownEditPopup(true);
      } else {
        console.log("식단 수정 팝업 표시 (로컬 데이터 사용)");
        setContentToEditMeal(content);
        setShowMealEditPopup(true);
      }
    }
  };

  const handleMealEditCancel = () => {
    setShowMealEditPopup(false);
    setContentToEditMeal(null);
  };

  const handleMealEditConfirm = async ({ title, meal, showWeeklyView }) => {
    if (!contentToEditMeal) return;

    try {
      // 서버에 제목 업데이트
      await updateInfoBoardContentOnServer(contentToEditMeal._id, {
        "dataAnalysis.title": title ? title.trim() : contentToEditMeal.dataAnalysis?.title,
        "contentGeneratorMeal.meal_schedule": meal ? meal : contentToEditMeal.contentGeneratorMeal?.meal_schedule,
        "showWeeklyView": showWeeklyView !== undefined ? showWeeklyView : (contentToEditMeal?.showWeeklyView || false),
      });

      // 목록 업데이트
      if (onContentListUpdate) {
        await onContentListUpdate();
      }
      
      // 중요: 편성 정보도 함께 업데이트해야 UI에 반영됨 (만약 편성된 콘텐츠라면)
      if (onLotationUpdate) {
        await onLotationUpdate();
      }
      
      setShowMealEditPopup(false);
      setContentToEditMeal(null);
    } catch (error) {
      // console.error("제목 수정 실패:", error);
      alert("식단 수정에 실패했습니다.");
    }
  };

  // 마크다운 수정 관련 핸들러들
  const handleMarkdownEditCancel = () => {
    setShowMarkdownEditPopup(false);
    setContentToEditMarkdown(null);
  };

  // 최종 저장 (서버에 업데이트)
  const handleMarkdownEditSave = async ({ title, markdown, markdownTitle }) => {
    if (!contentToEditMarkdown) return;

    try {
      // 서버에 마크다운과 제목 업데이트
      const updateData = {
        contentGeneratorMarkdown: markdown,
      };
      
      // 콘텐츠 제목이 변경된 경우에만 제목 업데이트
      if (title && title.trim() !== contentToEditMarkdown.dataAnalysis?.title) {
        updateData["dataAnalysis.title"] = title.trim();
      }
      
      // 마크다운 타이틀이 변경된 경우 업데이트
      const originalTitle = Array.isArray(contentToEditMarkdown.contentGeneratorTitle) &&
        contentToEditMarkdown.contentGeneratorTitle.length > 0
        ? Array.isArray(contentToEditMarkdown.contentGeneratorTitle[0])
          ? contentToEditMarkdown.contentGeneratorTitle[0]
          : contentToEditMarkdown.contentGeneratorTitle
        : [];
      
      if (markdownTitle[0] !== (originalTitle[0] || "") || 
          markdownTitle[1] !== (originalTitle[1] || "")) {
        updateData.contentGeneratorTitle = [markdownTitle];
      }
      
      await updateInfoBoardContentOnServer(contentToEditMarkdown._id, updateData);

      // 목록 업데이트
      if (onContentListUpdate) {
        await onContentListUpdate();
      }
      
      // 편성 정보도 함께 업데이트
      if (onLotationUpdate) {
        await onLotationUpdate();
      }

      setShowMarkdownEditPopup(false);
      setContentToEditMarkdown(null);
    } catch (error) {
      console.error("마크다운 수정 중 오류 발생:", error);
      alert("마크다운 수정에 실패했습니다.");
    }
  };

  const handleDeleteContent = async (contentId) => {
    try {
      // console.log("contentId", contentId);
      await updateInfoBoardContentOnServer(contentId, { deleteState: 1, isScheduled: 0 });

      const customerId = sessionStorage.getItem("customerId");
      const data = {
        content_ids: contentList.filter((content) => content.isScheduled === 1 && content._id !== contentId).map((content) => content._id),
        customer_id: customerId
      };
      await updateInfoBoardContentsOnServer(data);
      
      // 목록 업데이트
      if (onContentListUpdate) {
        await onContentListUpdate();
      }
      // 편성 정보도 업데이트
      if (onLotationUpdate) {
        await onLotationUpdate();
      }

      setShowConfirmPopup(false);
      setContentToDelete(null);
    } catch (error) {
      console.error("콘텐츠 삭제 실패:", error);
      alert("콘텐츠 삭제에 실패했습니다.");
    }
  };

  const displayedContentList = getDisplayedContentList();

  // 미리보기 창에서 뒤로가기를 누르면 대시보드 창으로 돌아가도록 설정
  useEffect(() => {
    const handlePopState = (e) => {
      if (!e.state?.overlay) {
        setShowTemplatePreview(false);
        setTemplateToPreview(null);
      }
      // 전체화면 해제
      if (document.fullscreenElement) {
        document.exitFullscreen().catch((err) => {
          console.log("전체화면 해제 실패:", err);
        });
      }
    };
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  return (
    <>
      <Container>
        <Header>
          <StatHeader2>
                    
            <H4 color="primary">{customerName} </H4>
            <H4 color="gray700">콘텐츠 편성 관리 </H4>
          </StatHeader2>
          <HeaderRight>
            <StyledContentButton onClick={handleAddContent}>
              <svg
                width={20}
                height={20}
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.154 2.99902H4.78352C4.14301 2.99902 3.62378 3.51826 3.62378 4.15876V16.5293C3.62378 17.1698 4.14301 17.689 4.78352 17.689H17.154C17.7945 17.689 18.3138 17.1698 18.3138 16.5293V4.15876C18.3138 3.51826 17.7945 2.99902 17.154 2.99902Z"
                  stroke="#256EF4"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M14.1474 9.39274L15.1005 10.3458L14.1474 11.2989M7.79353 9.39274L6.84045 10.3458L7.79353 11.2989M11.9235 7.1689L10.9705 6.21582L10.0174 7.1689M11.9235 13.5227L10.9705 14.4758L10.0174 13.5227"
                  stroke="#256EF4"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <Sub2 color="primary">콘텐츠 활성화 설정</Sub2>
            </StyledContentButton>
          </HeaderRight>
          </Header>
        <Header>
         <HeaderLeft>
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <TabContainer>
                {typeOptions.map((tab) => (
                  <Tab
                    key={tab.value}
                    active={viewFilter === tab.value}
                    onClick={() => setViewFilter(tab.value)}
                  >
                    {tab.label}
                  </Tab>
                ))}
              </TabContainer>
              {/* <TabContainer>
                {typeOptions.slice(7).map((tab) => (
                  <Tab
                    key={tab.value}
                    active={viewFilter === tab.value}
                    onClick={() => setViewFilter(tab.value)}
                  >
                    {tab.label}
                  </Tab>
                ))}
              </TabContainer> */}
            </div>
          </HeaderLeft>
        
        </Header>

        <ContentListWrap>
          {displayedContentList.length === 0 ? (
            <BoxWrap NoData style={{ height: "300px" }}>
              <img src={images.ListFillPrimary} alt="" />
              <Body2 color="gray700" align="center !important">
                콘텐츠가 없습니다.
              </Body2>
            </BoxWrap>
          ) : (
            <Table>
              <colgroup>
                <col width="52%" />
                <col width="14%" />
                <col width="24%" />
                <col width="12%" />
              </colgroup>
              <TableHeader>
                <tr>
                  <th>
                    <Body1 color="gray700" align="left">
                      콘텐츠 제목
                    </Body1>
                  </th>
                  <th>
                    <Body1 color="gray700" align="left">
                      제작일
                    </Body1>
                  </th>
                  <th>
                    <Body1 color="gray700" align="left">
                      콘텐츠 설정
                    </Body1>
                  </th>
                  <th>
                    <Body1 color="gray700" align="left">
                      
                    </Body1>
                  </th>                  
                </tr>
              </TableHeader>
              <TableBody>
                {displayedContentList.map((content) => (
                  <tr key={content._id}>
                    <td>
                      <ContentNameCell>
                        <div
                          style={{
                            fontSize: "20px",
                            fontFamily: "Pretendard",
                            fontWeight: "700",
                            color: "#323232",
                            lineHeight: "1.55",
                          }}
                        >
                          {content.dataAnalysis?.title}
                        </div>
                        <Body2 color="gray700" style={{ color: "#666666" }}>
                          {getConceptName(content.designConcept)}
                        </Body2>
                      </ContentNameCell>
                    </td>
                    <td>
                      <Body2 color="gray700" align="left">
                        {(() => {
                          const dateStr = content.createDate;
                          if (!dateStr) return "-";
                          const match = dateStr.match(
                            /^(.+?)\s+(오전|오후)\s+(.+)$/
                          );
                          if (match) {
                            const datePart = match[1];
                            const amPm = match[2];
                            const timePart = match[3];
                            return (
                              <>
                                {datePart}
                                <br />
                                <Body2 color="gray700" align="left">
                                  {amPm} {timePart}
                                </Body2>
                              </>
                            );
                          }
                          return dateStr;
                        })()}
                      </Body2>
                    </td>
                    <td>
                      <ActionButtonsCell>
                        <ButtonGroup>
                          <PreviewButton
                            type="button"
                            onClick={() => handleTemplatePreview(content._id)}
                          >
                            <svg
                              width="21"
                              height="21"
                              viewBox="0 0 21 21"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M10.4991 4.9375C14.2651 4.9376 17.6532 7.00578 18.712 9.81836C18.8158 10.0941 18.8308 10.4038 18.7374 10.6992C18.0917 12.7392 15.547 15.4374 10.4991 15.4375C5.43073 15.4375 2.93409 12.476 2.27936 10.7217C2.17268 10.4358 2.17158 10.1309 2.25983 9.85352C2.7197 8.40882 3.86624 7.17982 5.3194 6.32129C6.77927 5.4589 8.5994 4.9375 10.4991 4.9375ZM10.4991 6.27051C8.83591 6.27051 7.25005 6.7295 5.99713 7.46973C4.73751 8.21395 3.86349 9.2112 3.53034 10.2578L3.52936 10.2598C4.00367 11.5242 6.02377 14.1045 10.4991 14.1045C15.0269 14.1044 17.0129 11.7269 17.4659 10.2988V10.2979C17.4658 10.2964 17.4657 10.2929 17.4639 10.2881C16.6478 8.12022 13.8568 6.27061 10.4991 6.27051ZM10.4991 7.02148C12.2479 7.02148 13.666 8.43867 13.6661 10.1875C13.6661 11.9364 12.248 13.3545 10.4991 13.3545C8.75034 13.3543 7.33307 11.9363 7.33307 10.1875C7.33316 8.43878 8.75039 7.02166 10.4991 7.02148ZM10.4991 8.35449C9.48677 8.35467 8.66617 9.17516 8.66608 10.1875C8.66608 11.1999 9.48671 12.0213 10.4991 12.0215C11.5116 12.0215 12.3331 11.2 12.3331 10.1875C12.333 9.17505 11.5116 8.35449 10.4991 8.35449Z"
                                fill="#666666"
                              />
                            </svg>
                            미리보기
                          </PreviewButton>
                        </ButtonGroup>
                          <ButtonGroup>
                          <PreviewButton
                            type="button"
                            onClick={() => handleTypeChange(content)}
                          >
                           <svg
                            width={20}
                            height={20}
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                            d="M17.154 2.99902H4.78352C4.14301 2.99902 3.62378 3.51826 3.62378 4.15876V16.5293C3.62378 17.1698 4.14301 17.689 4.78352 17.689H17.154C17.7945 17.689 18.3138 17.1698 18.3138 16.5293V4.15876C18.3138 3.51826 17.7945 2.99902 17.154 2.99902Z"
                            stroke="#666666"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            />
                            <path
                            d="M14.1474 9.39274L15.1005 10.3458L14.1474 11.2989M7.79353 9.39274L6.84045 10.3458L7.79353 11.2989M11.9235 7.1689L10.9705 6.21582L10.0174 7.1689M11.9235 13.5227L10.9705 14.4758L10.0174 13.5227"
                            stroke="#666666"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            />
                        </svg>
                           설치 위치 설정
                          </PreviewButton>
                        </ButtonGroup>
                        
                        </ActionButtonsCell>
                        </td>
                        <td>
                        <ActionButtonsCell>
                        <ButtonGroup>
                          <EditButton
                            type="button"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              handleEditTitle(content);
                            }}
                          >
                            <svg
                              width="20"
                              height="21"
                              viewBox="0 0 20 21"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clipPath="url(#clip0_222_5931)">
                                <path
                                  d="M2.55835 14.504C2.52098 14.5415 2.5 14.5922 2.5 14.6452V17.4875C2.5 17.598 2.58954 17.6875 2.7 17.6875H5.54197C5.59512 17.6875 5.64609 17.6663 5.68362 17.6287L13.7001 9.58587C13.778 9.50773 13.7779 9.38127 13.6999 9.30326L10.8578 6.4611C10.7796 6.38291 10.6528 6.38301 10.5747 6.46133L2.55835 14.504ZM17.2583 6.05417C17.5833 5.72917 17.5833 5.20417 17.2583 4.87917L15.3083 2.92917C14.9833 2.60417 14.4583 2.60417 14.1333 2.92917L12.7498 4.31275C12.6716 4.39086 12.6717 4.51749 12.7498 4.5956L15.5919 7.43775C15.67 7.51586 15.7966 7.51586 15.8748 7.43775L17.2583 6.05417Z"
                                  stroke="#666666"
                                  strokeWidth="1.67"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_222_5931">
                                  <rect
                                    width="20"
                                    height="20"
                                    fill="white"
                                    transform="translate(0 0.1875)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                          </EditButton>
                          <DeleteButton
                            type="button"
                            onClick={() => {
                              setContentToDelete(content._id);
                              setShowConfirmPopup(true);
                            }}
                          >
                            <svg
                              width="20"
                              height="21"
                              viewBox="0 0 20 21"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clipPath="url(#clip0_992_2924)">
                                <path
                                  d="M16.8364 3.70215C17.2366 3.70215 17.5618 4.02663 17.562 4.42676C17.562 4.82711 17.2368 5.15234 16.8364 5.15234H16.4419V15.3652C16.4419 17.367 14.8196 18.9902 12.8179 18.9902H6.71533C4.71361 18.9902 3.09131 17.367 3.09131 15.3652V5.15234H2.69678C2.29664 5.1521 1.97217 4.82695 1.97217 4.42676C1.97243 4.02678 2.2968 3.70239 2.69678 3.70215H16.8364ZM4.54053 5.15234V15.3652C4.54053 16.5663 5.5143 17.54 6.71533 17.54H12.8179C14.0189 17.54 14.9927 16.5663 14.9927 15.3652V5.15234H4.54053ZM8.24854 7.12402C8.64858 7.12419 8.97289 7.44861 8.97314 7.84863V14.5791C8.97314 14.9793 8.64874 15.3045 8.24854 15.3047C7.84819 15.3047 7.52295 14.9794 7.52295 14.5791V7.84863C7.52321 7.44851 7.84835 7.12402 8.24854 7.12402ZM11.2837 7.12402C11.6839 7.12402 12.009 7.44851 12.0093 7.84863V14.5791C12.0093 14.9794 11.684 15.3047 11.2837 15.3047C10.8835 15.3045 10.5591 14.9794 10.5591 14.5791V7.84863C10.5593 7.4486 10.8836 7.12417 11.2837 7.12402ZM12.064 0.988281C12.4641 0.988474 12.7884 1.31279 12.7886 1.71289C12.7886 2.11312 12.4641 2.43828 12.064 2.43848H7.47119C7.07096 2.43834 6.74658 2.11315 6.74658 1.71289C6.74674 1.31276 7.07106 0.988422 7.47119 0.988281H12.064Z"
                                  fill="#666666"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_992_2924">
                                  <rect
                                    width="20"
                                    height="21"
                                    fill="white"
                                    transform="translate(0 0.1875)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                          </DeleteButton>
                        </ButtonGroup>
                      </ActionButtonsCell>
                    </td>
                  </tr>
                ))}
              </TableBody>
            </Table>
          )}
        </ContentListWrap>

        {isPopupOpen && (
          <MoleculeInfoContentPopup
            onClose={handleClosePopup}
            contentList={displayedContentList}
            selectedTab={selectedTab}
            lotationDetail={lotationDetail}
            onLotationUpdate={onLotationUpdate}
            onContentListUpdate={onContentListUpdate}
            // type = "InfoContent"
          />
        )}

          {showTypeSelectPopup && selectedContentForType && (
         <MoleculeEduInfoTypeSelectPopup
            onClose={handleCloseTypeSelectPopup}
            content={selectedContentForType}
            onUpdate={async () => {
              // Update both lotation detail and content list
              if (onLotationUpdate) {
                await onLotationUpdate();
              }
              if (onContentListUpdate) {
                await onContentListUpdate();
              }
            }}
          />
        )}
        {showContentSettingPopup && (
          <MoleculeContentSettingPopup
            onClose={handleCloseContentSettingPopup}
            lotationDetail={lotationDetail}
            onUpdate={onLotationUpdate}
          />
        )}
        {showConfirmPopup && contentToDelete && (
          <PopupWrap
            Warning
            title="정말 삭제 하시겠습니까?"
            message={<>해당 콘텐츠가 삭제됩니다.</>}
            buttonType="Outline"
            closeText="취소"
            confirmText="삭제"
            isModal={false}
            onCancel={() => {
              setShowConfirmPopup(false);
              setContentToDelete(null);
            }}
            onConfirm={() => handleDeleteContent(contentToDelete)}
          />
        )}

        {showMealEditPopup && contentToEditMeal && (
          <MoleculeMealEditPopup
            content={contentToEditMeal}
            onClose={handleMealEditCancel}
            onSave={handleMealEditConfirm}
          />
        )}

        {/* 마크다운 수정 팝업 */}
        {showMarkdownEditPopup && contentToEditMarkdown && (
          <MoleculeMarkdownEditPopup
            content={contentToEditMarkdown}
            onClose={handleMarkdownEditCancel}
            onSave={handleMarkdownEditSave}
          />
        )}

        {/* 복사 성공 팝업 */}
        {showCopySuccessPopup && (
          <PopupWrap
            Check
            title="클립보드에 복사가 완료되었습니다."
            message={
              copiedInfo.type === "오류"
                ? copiedInfo.content
                : `${copiedInfo.type}가 클립보드에 복사되었습니다.`
            }
            buttonType="Outline"
            confirmText="확인"
            isModal={false}
            onConfirm={() => {
              setShowCopySuccessPopup(false);
              setCopiedInfo({ type: "", content: "" });
            }}
          />
        )}
      </Container>

      {/* 미리보기 컴포넌트 */}
      {showTemplatePreview && contentsTypeState &&
        (contentsTypeState === "meal" ? (
          <OrganismDisplayViewInfoMealPreview
            template={templateToPreview}
            onClose={handleCloseTemplatePreview}
            title={templateToPreview?.title}
            mealData={previewMealData}
            noticeText={previewNoticeText}
            displayWidth={previewWidth}
            displayHeight={previewHeight}
          />
        ) : (
          <OrganismDisplayViewInfoPreview
            template={templateToPreview}
            onClose={handleCloseTemplatePreview}
            title={templateToPreview?.title}
            jsonData={previewJsonData}
            contentsPurpose={previewContentsPurpose}
            contentsDesignConcept={previewContentsDesignConcept}
            markdownData={previewMarkdownData}
            titleData={previewTitleData}
            displayWidth={previewWidth}
            displayHeight={previewHeight}
            contentsType={contentsTypeState}
            linkUrl={linkUrl}
          />
        ))}
    </>
  );
};

export default OrganismEduInfoContentList;

const Container = styled.div`
  width: 1240px;
  background: white;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0px 0px 20px 0px;
  gap: 20px;
`;

const TopTabContainer = styled.div`
  display: flex;
  gap: 24px;
  border-bottom: 1px solid ${palette.lineGray};
  width: 100%;
`;

const TopTab = styled.button`
  background: none;
  border: none;
  padding: 12px 4px;
  cursor: pointer;
  border-bottom: 2px solid
    ${(props) => (props.active ? palette.primary : "transparent")};
  margin-bottom: -1px;

  h4 {
    font-weight: ${(props) => (props.active ? "700" : "500")};
  }
`;


const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
`;

const YearMonth = styled.span`
  color: #323232;
  font-size: 36px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 36px;
`;

const TabContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  background: #eef2f7;
  border-radius: 24px;
  width: fit-content;
`;

const Tab = styled.button`
  height: 40px;
  min-width: 79px;
  padding: 4px 20px;
  background: ${(props) => (props.active ? "white" : "transparent")};
  border: 1px solid ${(props) => (props.active ? "#256EF4" : "transparent")};
  border-radius: 24px;
  cursor: pointer;
  color: #323232;
  font-size: 17px;
  font-family: Pretendard;
  font-weight: 400;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover {
    background: ${(props) =>
      props.active ? "white" : "rgba(255, 255, 255, 0.5)"};
  }
`;

const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  align-self: flex-start;
`;

const ContentListWrap = styled.div`
  width: 100%;
`;

const Table = styled.table`
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  background: ${palette.white};
  overflow: hidden;
`;

const TableHeader = styled.thead`
  background: #eef2f7;

  th {
    padding: 20px 16px;
    border-bottom: 1px solid ${palette.outlineGray};
  }
`;

const TableBody = styled.tbody`
  tr {
    &:hover {
      background: #f9fafb;
    }
    border-bottom: 1px solid ${palette.outlineGray};
  }

  td {
    padding: 20px 16px;
  }
`;

const PopupButton = styled.button`
  background: ${palette.brightBlue};
  color: ${palette.primary};
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;

  &:hover {
    background: ${palette.brightBlue}DD;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 40px;
`;

const PreviewButton = styled.button`
  background: ${palette.gray100};
  color: ${palette.gray700};
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  &:hover {
    background: ${palette.gray200};
  }
  white-space: nowrap;
`;

const EditButton = styled.button`
  color: #666666;
  border: none;
  padding: 4px 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;

  &:hover {
    svg {
      path {
        fill: rgb(73, 73, 73);
      }
    }
  }
`;

const DeleteButton = styled.button`
  color: #666666;
  border: none;
  padding: 4px 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;

  &:hover {
    svg {
      path {
        fill: rgb(73, 73, 73);
      }
    }
  }
`;

const ContentNameCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
`;

const ActionButtonsCell = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 40px;
`;

// 다이렉트 링크 관련 스타일드 컴포넌트들
const DirectLinkContainer = styled.div`
  margin-left: 0px;
`;

const StyledFrame = styled.div`
  align-self: stretch;
  justify-content: flex-start;
  align-items: center;
  display: inline-flex;
`;

const StyledIdSpan01 = styled.span`
  color: var(--color-text-subtle, #464c53);
  font-size: 17px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 25.5px;
  word-wrap: break-word;
`;

const StyledIdSpan02 = styled.span`
  color: var(--color-text-primary, #0b50d0);
  font-size: 17px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 25.5px;
  word-wrap: break-word;
`;

const CopyButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  margin-left: 8px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: ${palette.gray100};
  }
`;

const StyledContentButton = styled(Button).attrs({
  Large: true,
  PrimaryLightest: true,
  Fill: true,
})`
  display: inline-flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background: #e6f0ff !important;
  }
`;

const FilterGroup = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

const FilterItem = styled.label`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  
  span {
    color: #323232;
    font-size: 16px;
    font-family: Pretendard;
    font-weight: 400;
  }
`;

// 제목 수정 팝업 오버레이
const TitleEditPopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
`;


const StatHeader2 = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
`;